import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
  Paper, Typography,
} from '@material-ui/core';
// const
import { SUPER_ADMIN } from '../../utils/const/user';

import Changes from '../../components/UploadView/Changes';

import {
  updateProductChanges,
  uploadProductFile,
} from '../../requests/api/product';

import useStyles from './styles';

function ProductsImportView() {
  const classes = useStyles();
  const { t } = useTranslation();

  const account = useSelector((state) => state.account);
  const [uploadDifference, setUploadDifference] = useState([]);

  if (account.user.role !== SUPER_ADMIN) {
    window.location.href = '/home';
  }

  const tableHeaders = [
    {
      id: 'company_id',
      label: t('products.columnNames.company_id'),
      minWidth: 60,
    },
    {
      id: 'name',
      label: t('products.columnNames.name'),
      minWidth: 160,
    },
    {
      id: 'internal_code',
      label: t('products.columnNames.internal_code'),
      minWidth: 120,
    },
    {
      id: 'ean',
      label: 'EAN',
      minWidth: 120,
    },
    {
      id: 'sub_category',
      label: t('products.columnNames.sub_category'),
      minWidth: 120,
    },
    {
      id: 'distributor',
      label: t('products.columnNames.distributor'),
      minWidth: 120,
    },
    {
      id: 'size',
      label: t('products.columnNames.size'),
      minWidth: 120,
    },
    {
      id: 'category_code',
      label: t('products.columnNames.category_code'),
      minWidth: 120,
    },
    {
      id: 'deleted',
      label: t('products.columnNames.deleted'),
    },
  ];

  const properties = ['CompanyId', 'Name', 'InternalCode', 'Ean', 'SubCategory', 'Distributor', 'Size', 'Category', 'Deleted'];

  return (
    <div className={classes.content}>
      <Typography className={classes.title} variant="h3" color="textPrimary">
        {t('products.uploadFile')}
      </Typography>
      <Paper className={classes.changesTable}>
        <Changes
          properties={properties}
          tableHeaders={tableHeaders}
          uploadDifference={uploadDifference || []}
          setUploadDifference={setUploadDifference}
          updateFunction={updateProductChanges}
          uploadFunction={uploadProductFile}
        />
      </Paper>
    </div>
  );
}

export default ProductsImportView;
